/* eslint-disable @typescript-eslint/naming-convention */
export enum UserStatusDelta {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  // DELETED = 'DELETED' // This may be used to delete the entire user record from DB (ex. diritto all'oblio)
}

export enum Gender {
  MALE = 'M',
  FEMALE = 'F',
}

export enum Venue {
  SEDE = 'SEDE',
  NEGOZI = 'NEGOZI',
  ALTRO = 'ALTRO',
}

export enum Title {
  DIRIGENTE = 'Dirigente',
  QUADRO = 'Quadro',
  IMPIEGATO = 'Impiegato',
  OPERAIO = 'Operaio',
  APPR_IMPIEGATO = 'Appr. Impiegato',
  APPR_OPERAIO = 'Appr. Operaio',
  TIROC_CURRICULARE = 'Tiroc. Curriculare',
  TIROC_EXTRA_CURRIC = 'Tiroc. Extra Curric.',
  BORSA_DI_STUDIO = 'Borsa di Studio',
  ALTERN_SCUOLA_LAVORO = 'Altern.Scuola/Lavoro',
}

export enum Management {
  AFFARI_GEN = 'AFFARI GEN.',
  AFFARI_LEGALI_E_SOCIETARI = 'AFFARI LEGALI E SOCIETARI',
  ALLESTIMENTO_PREAPERTURA = 'ALLESTIMENTO PREAPERTURA',
  ALTRO = 'ALTRO',
  AMM_FIN_CONTR = 'AMM.FIN.CONTR',
  ANALYTICS_E_B_I = 'ANALYTICS E B.I.',
  ANC_E_OUTSOURCING = 'ANC E OUTSOURCING',
  ASSENTI = 'ASSENTI',
  ASSIC_QUAL = 'ASSIC. QUAL.',
  ATLANTIC = 'ATLANTIC',
  ATLANTIC_P5 = 'ATLANTIC P5',
  BAR_ATLANTIC = 'BAR ATLANTIC',
  COMMERCIALE = 'COMMERCIALE',
  COMUNICAZIONE = 'COMUNICAZIONE',
  COMUNICAZIONE_E_MARKETING = 'COMUNICAZIONE E MARKETING',
  COOPERATIVE = 'COOPERATIVE',
  CORPORATE_SUSTAINABILITY = 'CORPORATE SUSTAINABILITY',
  COSTI_GENERALI = 'COSTI GENERALI',
  ECOMMERCE = 'E-COMMERCE',
  ESSERBELLA = 'ESSERBELLA',
  ESTERNI = 'ESTERNI',
  FORMAZIONE = 'FORMAZIONE',
  GENERALE = 'GENERALE',
  GUARDIE = 'GUARDIE',
  INTERNAL_AUDIT = 'INTERNAL AUDIT',
  ISL = 'ISL',
  IT = 'IT',
  LAESSE_MARKET = 'LAESSE MARKET',
  LOGISTICA = 'LOGISTICA',
  NEGOZI_WEB_REPARTI_E_DRIVE = 'NEGOZI WEB - REPARTI E DRIVE',
  NEGOZIO = 'NEGOZIO',
  NEGOZIO_WEB_DARKSTORE = 'NEGOZIO WEB - DARKSTORE',
  PANIFICAZIONE_CENTRALIZZATA = 'PANIFICAZIONE CENTRALIZZATA',
  PIANIFICAZIONE_NEGOZI = 'PIANIFICAZIONE NEGOZI',
  PRODUZIONI = 'PRODUZIONI',
  PROFUMERIA_ESSERBELLA = 'PROFUMERIA ESSERBELLA',
  PROGETTI_EDITORIALI = 'PROGETTI EDITORIALI',
  RILEVAMENTO_PREZZI = 'RILEVAMENTO PREZZI',
  RISORSE_UMANE_E_ORGANIZZAZIONE = 'RISORSE UMANE E ORGANIZZAZIONE',
  SEDE_FIRENZE = 'SEDE FIRENZE',
  SEGR_GEN = 'SEGR. GEN.',
  SICUREZZA_E_TUTELA_DEL_PATRIMONIO = 'SICUREZZA E TUTELA DEL PATRIMONIO',
  SOCIETA = 'SOCIETA\'',
  SVILUPPO = 'SVILUPPO',
  TECNICA = 'TECNICA',
  TECNICA_FIRENZE = 'TECNICA FIRENZE',
  UFFICIO_STAMPA = 'UFFICIO STAMPA',
  VENDITE = 'VENDITE',
}

export enum Level {
  LIVCC = 'LIVCC',
  'LIV.Q' = 'LIV.Q',
  'LIV.1' = 'LIV.1',
  'LIV.2' = 'LIV.2',
  'LIV.3' = 'LIV.3',
  'LIV.4' = 'LIV.4',
  'LIV.5' = 'LIV.5',
  'LIV.6' = 'LIV.6',
  'LIV.7' = 'LIV.7',
  'LIV.99' = '99',
  'LIVAD' = 'LIVAD',
  'LIVVR' = 'LIVVR',
  'DIR' = 'DIR',
  'LIV.QA' = 'LIV.QA',
  'LIV.QB' = 'LIV.QB',
  'LIV.6S' = 'LIV.6S',
  'REG' = 'REG',
  'TBD' = 'TBD',
  'LIVST' = 'LIVST',
}

export enum CompanyId {
  E001 = 'E001',
  E002 = 'E002',
  E073 = 'E073',
  E136 = 'E136',
}

export enum Company {
  ESSELUNGA_SPA = 'Esselunga S.p.A.',
  ATLANTIC_SRL = 'Atlantic S.r.l.',
  ESSERBELLA_SPA = 'EsserBella S.p.A.',
}

export enum Polo {
  MILANO = 'MILANO',
  FIRENZE = 'FIRENZE',
  BIANDRATE = 'BIANDRATE',
}

export enum CollarType {
  WHITE_COLLAR = 'WHITE COLLAR',
  BLUE_COLLAR = 'BLUE COLLAR',
}

export enum Country {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AN = 'AN',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CS = 'CS',
  CU = 'CU',
  CV = 'CV',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  EU = 'EU',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NT = 'NT',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  OR = 'OR',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  ST = 'ST',
  SV = 'SV',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TP = 'TP',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  UN = 'UN',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  XK = 'XK',
  XM = 'XM',
  XS = 'XS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW',
}

export enum MaritalStatus {
  SINGLE = 'Single',
  MARRIED = 'Coniug',
  WIDOW = 'Vedov.',
  DIVORCED = 'Divorz',
  CIVIL_UNION = 'UniCiv',
  SEPARATED = 'Separ.',
}
